import { TabsContent, TabsList, TabsRoot, TabsTrigger } from "@flint/ui";
import type { BillStatusFilter } from "./types.ts";

export interface BillStatusTabsProps {
  value: BillStatusFilter;
  onChange: (next: BillStatusFilter) => void;
  counts: Record<BillStatusFilter, number>;
}

const TABS: ReadonlyArray<{ value: BillStatusFilter; label: string; warn?: boolean }> = [
  { value: "all", label: "All" },
  { value: "draft", label: "Draft" },
  // "Awaiting" is the catch-all for un-paid bills (review +
  // approval_pending + ready_to_pay). The narrower "Awaiting approval"
  // (approval_pending only) lives on the Approval banner above.
  { value: "awaiting", label: "Awaiting", warn: true },
  { value: "approved", label: "Approved" },
  { value: "paid", label: "Paid" },
  { value: "recurring", label: "Recurring" },
];

export function BillStatusTabs({ value, onChange, counts }: BillStatusTabsProps) {
  return (
    <TabsRoot value={value} onValueChange={(v) => onChange(v as BillStatusFilter)}>
      <TabsList aria-label="Bill status">
        {TABS.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            count={counts[tab.value]}
            countTone={tab.warn ? "warn" : "default"}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {/* Each Radix TabsTrigger sets aria-controls to a panel id; the filtered
          table below isn't a Radix panel, so without these the references dangle
          (axe aria-valid-attr-value, critical). forceMount keeps an empty,
          screen-reader-hidden panel per tab so every reference resolves. */}
      {TABS.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} forceMount className="hidden" aria-hidden />
      ))}
    </TabsRoot>
  );
}
